export default "__VITE_ASSET__437a4de5__"